export enum LayoutPresets {
  default = '!p-3',
  noPadding = '!p-0',
  transparent = '!p-0 !bg-transparent !shadow-none !border-none',
}

// export type PresetsPropsI = {
//   [key in LayoutPresets]: LayoutState;
// };
//
// export const PresetsProps: PresetsPropsI = {
//   [LayoutPresets.default]: {
//     breadcrumbs: true,
//     content: {
//       className: 'flex flex-col space-y-4 p-5 w-full',
//     },
//     card: {
//       className: 'h-[calc(100%-32px)] max-h-full flex shadow-xl',
//       classNames: {
//         body: 'grow w-full overflow-y-auto',
//       },
//     },
//     preset: LayoutPresets.default,
//   },
//   [LayoutPresets.noPadding]: {
//     breadcrumbs: true,
//     content: {
//       className: 'flex flex-col space-y-4 p-5 w-full',
//     },
//     card: {
//       className: 'h-[calc(100%-32px)] max-h-full flex shadow-xl overflow-hidden',
//       classNames: {
//         body: 'grow w-full overflow-hidden !p-0',
//       },
//     },
//     preset: LayoutPresets.noPadding,
//   },
//   [LayoutPresets.dashboardList]: {
//     breadcrumbs: true,
//     content: {
//       className: 'flex flex-col space-y-4 p-5',
//     },
//     card: {
//       className: 'h-[calc(100%-32px)] max-h-full flex  shadow-xl',
//       classNames: {
//         body: 'grow w-full overflow-y-hidden',
//       },
//     },
//     preset: LayoutPresets.dashboardList,
//   },
//   [LayoutPresets.dashboard]: {
//     breadcrumbs: false,
//     content: {
//       className: 'flex w-full h-full',
//     },
//     card: {
//       className: 'p-0 w-full h-full max-h-full flex border-none bg-transparent',
//       classNames: {
//         body: 'grow w-full !p-0',
//       },
//     },
//     preset: LayoutPresets.dashboard,
//   },
//   [LayoutPresets.login]: {
//     breadcrumbs: false,
//     content: {
//       className: 'flex flex-col space-y-4 p-5',
//     },
//     card: {
//       className: 'h-full max-h-full flex shadow-xl',
//       classNames: {
//         body: 'grow w-full',
//       },
//     },
//
//     preset: LayoutPresets.login,
//   },
//   [LayoutPresets.noPaddingBottom]: {
//     breadcrumbs: true,
//     content: {
//       className: 'flex flex-col space-y-4 p-5',
//     },
//     card: {
//       className: 'h-[calc(100%-32px)] max-h-full flex  shadow-xl',
//       classNames: {
//         body: 'grow w-full !pb-[10px] overflow-y-auto',
//       },
//     },
//     preset: LayoutPresets.noPaddingBottom,
//   },
//   [LayoutPresets.noPaddingY]: {
//     breadcrumbs: true,
//     content: {
//       className: 'flex flex-col space-y-4 p-5',
//     },
//     card: {
//       className: 'h-[calc(100%-32px)] max-h-full flex  shadow-xl',
//       classNames: {
//         body: 'grow w-full !pb-[10px] !pt-[10px] overflow-y-auto',
//       },
//     },
//     preset: LayoutPresets.noPaddingY,
//   },
// };